'use client';

import { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { Sidebar } from './sidebar';
import { useAuth } from '@/lib/integrations/supabase';
import { useRealtimeSubscription } from '@/lib/integrations/supabase/realtime';

// Lazy load AssistantDock - it has heavy dependencies (lottie, markdown, ai-sdk)
// This significantly improves page navigation speed
const AssistantDock = dynamic(
  () => import('./assistant-dock').then(mod => ({ default: mod.AssistantDock })),
  { ssr: false }
);

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const { businessId } = useAuth();

  // Enable real-time updates globally for all authenticated pages
  useRealtimeSubscription(businessId);

  return (
    <div className="relative min-h-screen min-h-[100dvh]">
      <Sidebar />

      {/* Sidebar always starts collapsed (w-20), expands on hover */}
      {/* Using logical margin (ms = margin-start) for RTL support */}
      <main className="relative z-10 pt-mobile-header pb-assistant transition-all duration-300 lg:ms-24">
        <div className="min-h-screen min-h-[100dvh]">
          {children}
        </div>
      </main>

      <AssistantDock />
    </div>
  );
}

